import {Card, CardBody,} from 'reactstrap';

import {ButtonCancel} from "../../../components/buttons/buttonsActions";
import {ScheduleForm} from "./_form";
import React from "react";
import {ScheduleList} from "./_list";

class Schedule extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            activity: this.props.activity,

            editMode: false,
            itemToEdit: null
        };

        this.refreshList = this.refreshList.bind(this);
        this.setForm = this.setForm.bind(this);
        this.editItem = this.editItem.bind(this);
        this.refList = React.createRef();
        this.refForm = React.createRef();
    }

    async refreshList() {
        await this.refList.current.refreshList();
    }

    setForm() {
        this.props.setForm(false, false, undefined);
    }

    editItem(editModeP, item) {
        this.setState({
            editMode: editModeP,
            itemToEdit: item
        })

        this.refForm.current.setFormEdit(item);
    }

    render() {
        return (
            <Card>


                <ScheduleForm activity={this.state.activity} ref={this.refForm} refreshList={this.refreshList}
                              setForm={this.setForm} item={this.state.itemToEdit}/>

                <ScheduleList activity={this.state.activity} ref={this.refList} editItem={this.editItem}/>

                <CardBody className="border-top">
                    <div className="float-right">
                        <ButtonCancel onClick={this.props.setForm}/>
                    </div>
                </CardBody>
            </Card>
        )
    }
}

export default Schedule;